import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { IconSearch } from "@tabler/icons-react";
import { MButton } from "@/components/ui/atoms/MButtons";
import MaatraLogo from "@/components/ui/atoms/MaatraLogo";
import styles from "./SignupLanding.module.css";
import {
  getPreferredLoginMethod,
  clearStoragePreservingTours,
} from "@/utils/storage-utils";

const SignupLanding: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const preferredMethod = getPreferredLoginMethod() || "mobile";

  useEffect(() => {
    clearStoragePreservingTours();
  }, []);

  return (
    <div className={styles.container}>
      {/* Top gradient section with watermark and logo circle */}
      <div className={styles.topSection}>
        <div className={styles.watermark}>
          <MaatraLogo fill="#e9e3f5" size={380} />
        </div>
        <div className={styles.logoCircleWrapper}>
          <div className={styles.logoCircleInner}>
            <MaatraLogo fill="#fff" size={45} />
          </div>
        </div>
      </div>

      {/* Bottom content */}
      <div className={styles.bottomSection}>
        <div className={styles.textBlock}>
          <h1 className={styles.title}>
            <span className={styles.titleHighlight}>
              {t("auth.signupLanding.titleHighlight")}
            </span>
            <span className={styles.titleRest}>
              {t("auth.signupLanding.titleRest")}
            </span>
          </h1>
          <div className={styles.trustBadges}>
            <span>{t("auth.signupLanding.trustBadge1")}</span>
            <span className={styles.dot}>·</span>
            <span>{t("auth.signupLanding.trustBadge2")}</span>
            <span className={styles.dot}>·</span>
            <span>{t("auth.signupLanding.trustBadge3")}</span>
          </div>
        </div>

        <div className={styles.spacer} />

        <div className={styles.buttonContainer}>
          <MButton
            variant="filled"
            size="lg"
            onClick={() => navigate("/register/consent")}
          >
            {t("auth.signupLanding.createAccount")}
          </MButton>

          <MButton
            variant="outline"
            size="lg"
            onClick={() => navigate("/how-maatra-works")}
            className={styles.howItWorksBtn}
          >
            <IconSearch size={20} color="#4c189a" />
            {t("auth.signupLanding.howItWorks")}
          </MButton>

          <div className={styles.loginRow}>
            <span className={styles.alreadyUser}>
              {t("auth.signupLanding.alreadyUser")}
            </span>
            <button
              type="button"
              className={styles.loginLink}
              onClick={() =>
                navigate("/login/form", {
                  state: { mode: preferredMethod, isLogin: true },
                })
              }
            >
              {t("auth.signupLanding.loginLink")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SignupLanding;
